<template>
  <slider />

  <the-nav />

  <div class="main-wrap">
    <div class="not-found">Page not found</div>

    <bonuses-line />

    <play-line />
  </div>
</template>

<script>
import Slider from '@/components/sliders/Slider'
import PlayLine from '@/components/PlayLine'
import BonusesLine from '@/components/BonusesLine.vue'
import TheNav from '@/components/TheNav'

export default {
  name: 'NotFound',
  components: { Slider, PlayLine, BonusesLine, TheNav },
}
</script>

<style scoped>
.not-found {
  font-weight: bold;
  font-size: 40px;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
  padding: 100px 0 200px;
}
</style>
